const WishFormSection = ({ title = "" }) => {
  return <p className="lead border-bottom text-primary pt-2">{title}</p>;
};

export default WishFormSection;
